import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/workflows/Main.css";

const headers = [
  "Select", // checkbox
  "Document No.",
  "Document Revision",
  "Document Version",
  "Document Title",
  "Initiator",
  "Step Name",
  "Action",
  "Assigned to",
  "Date In",
  "Date Due",
  "Original Due Date",
  "Date Completed",
  "Step Status",
  "Step Outcome",
  "Days Late",
];

const sampleData = [
  {
    usergroup: "Supplementary Documents",
    workflowNo: "WF - 060981",
    name: "BESS PLANT-PSS-FACTORY ACCEPTANCE TEST (FAT) REPORT SUBMISSION OF EMERGENCY DIESEL GENERATOR (500KVA), M/S. ALKHORAYEF COMMERCIAL CO., PM210012-LTG511-INC-BESS- 00033. (LOT-01)",
    docNo: "PM210012-LTG511-ZR3-00035",
    revision: "03",
    version: "17",
    title:
      "BESS PLANT-PSS-FACTORY ACCEPTANCE TEST (FAT) REPORT SUBMISSION OF EMERGENCY DIESEL GENERATOR (500KVA), M/S. ALKHORAYEF COMMERCIAL CO., PM210012-LTG511-INC-BESS- 00033. (LOT-01) REV00-GENERATION PACKAGE (BESS PSS)",
    initiator: "Mr Yasin Chipolkar - Air Products EPC",
    stepName: "Review",
    action: "",
    assignedTo:
      "Abdallah Hussein - Air Products EPC  Mr Ameer Hamza - Air Products EPC Mr Hafez Fares - Air Products EPCMr Khaled Guerrout - Air Products EPC Mr Mian Muhammad Imran - Air Products EPC Mr Mohammed Osama Haggag - Air Products EPC Mr Nouman Masood-Air Products EPC Mr Rajiv Gupta - Air Products EPC Mr Ramy Barakat - Air Products EPC Mr Saunak Bhatt - Air Products EPC Mr Suresh Reakulapally - Air Products EPC Mr Vimalesh Jagannath - Air Products EPC Mr Vinod Kavunkal-Air Products EPC Mr Vivek Dhanotiya - Air Products EPC",
    dateIn: "16/06/2025",
    dateDue: "22/06/2025",
    ogDueDate: "22/06/2025",
    dateCompleted: "",
    stepStatus: "Current",
    stepOutcome: "Pending",
    daysLate: "",
  },
  {
    usergroup: "Supplementary Documents",
    workflowNo: "WF - 060981",
    name: "BESS PLANT-PSS-FACTORY ACCEPTANCE TEST (FAT) REPORT SUBMISSION OF EMERGENCY DIESEL GENERATOR (500KVA), M/S. ALKHORAYEF COMMERCIAL CO., PM210012-LTG511-INC-BESS- 00033. (LOT-01)",
    docNo: "PM210012-LTG511-ZR3-00035",
    revision: "03",
    version: "17",
    title:
      "BESS PLANT-PSS-FACTORY ACCEPTANCE TEST (FAT) REPORT SUBMISSION OF EMERGENCY DIESEL GENERATOR (500KVA), M/S. ALKHORAYEF COMMERCIAL CO., PM210012-LTG511-INC-BESS- 00033. (LOT-01) REV00-GENERATION PACKAGE (BESS PSS)",
    initiator: "Mr Yasin Chipolkar - Air Products EPC",
    stepName: "Review",
    action: "",
    assignedTo:
      "Abdallah Hussein - Air Products EPC  Mr Ameer Hamza - Air Products EPC Mr Hafez Fares - Air Products EPCMr Khaled Guerrout - Air Products EPC Mr Mian Muhammad Imran - Air Products EPC Mr Mohammed Osama Haggag - Air Products EPC Mr Nouman Masood-Air Products EPC Mr Rajiv Gupta - Air Products EPC Mr Ramy Barakat - Air Products EPC Mr Saunak Bhatt - Air Products EPC Mr Suresh Reakulapally - Air Products EPC Mr Vimalesh Jagannath - Air Products EPC Mr Vinod Kavunkal-Air Products EPC Mr Vivek Dhanotiya - Air Products EPC",
    dateIn: "16/06/2025",
    dateDue: "22/06/2025",
    ogDueDate: "22/06/2025",
    dateCompleted: "",
    stepStatus: "Current",
    stepOutcome: "Pending",
    daysLate: "",
  },
 
];

const Main = () => {
  const navigate = useNavigate();

  const [openRows, setOpenRows] = useState({});

  const toggleRow = (index) => {
    setOpenRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="search-workflows-container">
      <div className="workflow-header">
        <div className="title">
          <div className="">Search Workflows Assigned to me</div>
        </div>
        <div className="workflow-actions">
          <div className="save-search-as">
            <div className="">Save Search As</div>
          </div>
          <div className="saved-searches">
            <div className="saved">Saved Searches</div>
            <div className="icon-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 18 18"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="search-workflows-body">
        <div className="fields">
          <div className="field">
            <div className="row1">
              <div className="col1">
                <div className="name">Workflow Status</div>
                <div className="">
                  <select>
                    <option value="">Select a value</option>
                    <option value="">Completed</option>
                    <option value="">In Progress</option>
                    <option value="">Terminated</option>
                  </select>
                </div>
              </div>
              <div className="col1">
                <div className="name">Step Status</div>
                <div className="">
                  <select>
                    <option value="">Select a value</option>
                    <option value="">Current</option>
                    <option value="">Overdew</option>
                    <option value="">Completed</option>
                    <option value="">Skipped</option>
                    <option value="">Terminated</option>
                  </select>
                </div>
              </div>
              <div className="col1">
                <div className="name">Step Outcome</div>
                <div className="">
                  <select>
                    <option value="">Select a value</option>
                    <option value="">CODE 1 - Rejected</option>
                    <option value="">CODE 2 - Comments as Noted</option>
                    <option value="">CODE 4 - No Comments</option>
                    <option value="">
                      CODE 5 - Accepted for information only
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row1">
              <div className="col1">
                <div className="name">Workflow No.</div>
                <div className="">
                  <input type="text" />
                </div>
              </div>
              <div className="col1">
                <div className="name">Document No.</div>
                <div className="">
                  <input type="text" />
                </div>
              </div>
              <div className="col1">
                <div className="name">Initiator</div>
                <div className="">
                  <input type="text" placeholder="Enter search query here" />
                </div>
              </div>
            </div>
            <div className="row1">
              <div className="col1">
                <div className="name">Assigned To</div>
                <div className="">
                  <input type="text" placeholder="Enter search query here" />
                </div>
              </div>
              <div className="col1">
                <div className="name">Workflow Name</div>
                <div className="">
                  <input type="text" />
                </div>
              </div>
              <div className="col1">
                <div className="name">Step Name</div>
                <div className="">
                  <select>
                    <option value="">Select a value</option>
                    <option value="">Review</option>
                    <option value="">Consolidation</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row2">
              <div className="col1">
                <div className="name">Date Range</div>
                <div className="date-range">
                  <div className="date-picker">
                    <div className="select">Select</div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="#949494"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 18 18"
                      >
                        <path d="M 4.5 6.75 L 9 11.25 L 13.5 6.75" />
                      </svg>
                    </div>
                  </div>
                  <div className="date-picker">
                    <div className=""></div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="#949494"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        viewBox="0 0 18 18"
                      >
                        <path d="M 4.5 6.75 L 9 11.25 L 13.5 6.75" />
                      </svg>
                    </div>
                  </div>
                  <div className="date-picker">
                    <div className=""></div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="#949494"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        viewBox="0 0 18 18"
                      >
                        <path d="M 1.5 9 C 1.5 6.17157 1.5 4.75736 2.37868 3.87868 C 3.25736 3 4.67157 3 7.5 3 H 10.5 C 13.3284 3 14.7427 3 15.6213 3.87868 C 16.5 4.75736 16.5 6.17157 16.5 9 V 10.5 C 16.5 13.3284 16.5 14.7427 15.6213 15.6213 C 14.7427 16.5 13.3284 16.5 10.5 16.5 H 7.5 C 4.67157 16.5 3.25736 16.5 2.37868 15.6213 C 1.5 14.7427 1.5 13.3284 1.5 10.5 V 9 Z" />
                        <path d="M 5.25 3 V 1.875" />
                        <path d="M 12.75 3 V 1.875" />
                        <path d="M 1.875 6.75 H 16.125" />
                        <path d="M 13.5 12.75 C 13.5 13.1642 13.1642 13.5 12.75 13.5 C 12.3358 13.5 12 13.1642 12 12.75 C 12 12.3358 12.3358 12 12.75 12 C 13.1642 12 13.5 12.3358 13.5 12.75 Z" />
                        <path d="M 13.5 9.75 C 13.5 10.1642 13.1642 10.5 12.75 10.5 C 12.3358 10.5 12 10.1642 12 9.75 C 12 9.33578 12.3358 9 12.75 9 C 13.1642 9 13.5 9.33578 13.5 9.75 Z" />
                        <path d="M 9.75 12.75 C 9.75 13.1642 9.41422 13.5 9 13.5 C 8.58578 13.5 8.25 13.1642 8.25 12.75 C 8.25 12.3358 8.58578 12 9 12 C 9.41422 12 9.75 12.3358 9.75 12.75 Z" />
                        <path d="M 9.75 9.75 C 9.75 10.1642 9.41422 10.5 9 10.5 C 8.58578 10.5 8.25 10.1642 8.25 9.75 C 8.25 9.33578 8.58578 9 9 9 C 9.41422 9 9.75 9.33578 9.75 9.75 Z" />
                        <path d="M 6 12.75 C 6 13.1642 5.66421 13.5 5.25 13.5 C 4.83579 13.5 4.5 13.1642 4.5 12.75 C 4.5 12.3358 4.83579 12 5.25 12 C 5.66421 12 6 12.3358 6 12.75 Z" />
                        <path d="M 6 9.75 C 6 10.1642 5.66421 10.5 5.25 10.5 C 4.83579 10.5 4.5 10.1642 4.5 9.75 C 4.5 9.33578 4.83579 9 5.25 9 C 5.66421 9 6 9.33578 6 9.75 Z" />
                      </svg>
                    </div>
                  </div>
                  <div className="date-picker">
                    <div className=""></div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="#949494"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        viewBox="0 0 18 18"
                      >
                        <path d="M 1.5 9 C 1.5 6.17157 1.5 4.75736 2.37868 3.87868 C 3.25736 3 4.67157 3 7.5 3 H 10.5 C 13.3284 3 14.7427 3 15.6213 3.87868 C 16.5 4.75736 16.5 6.17157 16.5 9 V 10.5 C 16.5 13.3284 16.5 14.7427 15.6213 15.6213 C 14.7427 16.5 13.3284 16.5 10.5 16.5 H 7.5 C 4.67157 16.5 3.25736 16.5 2.37868 15.6213 C 1.5 14.7427 1.5 13.3284 1.5 10.5 V 9 Z" />
                        <path d="M 5.25 3 V 1.875" />
                        <path d="M 12.75 3 V 1.875" />
                        <path d="M 1.875 6.75 H 16.125" />
                        <path d="M 13.5 12.75 C 13.5 13.1642 13.1642 13.5 12.75 13.5 C 12.3358 13.5 12 13.1642 12 12.75 C 12 12.3358 12.3358 12 12.75 12 C 13.1642 12 13.5 12.3358 13.5 12.75 Z" />
                        <path d="M 13.5 9.75 C 13.5 10.1642 13.1642 10.5 12.75 10.5 C 12.3358 10.5 12 10.1642 12 9.75 C 12 9.33578 12.3358 9 12.75 9 C 13.1642 9 13.5 9.33578 13.5 9.75 Z" />
                        <path d="M 9.75 12.75 C 9.75 13.1642 9.41422 13.5 9 13.5 C 8.58578 13.5 8.25 13.1642 8.25 12.75 C 8.25 12.3358 8.58578 12 9 12 C 9.41422 12 9.75 12.3358 9.75 12.75 Z" />
                        <path d="M 9.75 9.75 C 9.75 10.1642 9.41422 10.5 9 10.5 C 8.58578 10.5 8.25 10.1642 8.25 9.75 C 8.25 9.33578 8.58578 9 9 9 C 9.41422 9 9.75 9.33578 9.75 9.75 Z" />
                        <path d="M 6 12.75 C 6 13.1642 5.66421 13.5 5.25 13.5 C 4.83579 13.5 4.5 13.1642 4.5 12.75 C 4.5 12.3358 4.83579 12 5.25 12 C 5.66421 12 6 12.3358 6 12.75 Z" />
                        <path d="M 6 9.75 C 6 10.1642 5.66421 10.5 5.25 10.5 C 4.83579 10.5 4.5 10.1642 4.5 9.75 C 4.5 9.33578 4.83579 9 5.25 9 C 5.66421 9 6 9.33578 6 9.75 Z" />
                      </svg>
                    </div>
                  </div>
                  <div className="date-query">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="#04395f"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 18 18"
                      >
                        <path d="M 9 3.75 V 14.25 M 3.75 9 H 14.25" />
                      </svg>
                    </div>
                    <div className="query">Add another date query</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="search-bar-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#181818" /* Icon color */
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="16" y1="16" x2="22" y2="22"></line>
              </svg>
              <input type="text" placeholder="Super search" />
            </div>
          </div>
        </div>
        <div className="workflow-middle">
          <div className="left">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                stroke="#949494"
                viewBox="0 0 24 24"
              >
                <rect
                  x="23.5"
                  y="0.5"
                  width="23"
                  height="23"
                  rx="4.5"
                  transform="rotate(90 23.5 0.5)"
                />
                <path
                  d="M 16.0504 15 C 16.9745 15 17.4365 15 17.6738 14.8605 C 17.8802 14.7393 18.0003 14.5554 18 14.361 C 17.9997 14.1374 17.711 13.8718 17.1337 13.3406 L 13.0834 9.6134 C 12.7131 9.2726 12.5279 9.1023 12.3042 9.0406 C 12.1081 8.9865 11.8919 8.9865 11.6958 9.0406 C 11.4721 9.1023 11.2869 9.2726 10.9166 9.6134 L 6.8663 13.3406 C 6.289 13.8718 6.0003 14.1374 6 14.361 C 5.9997 14.5554 6.1198 14.7393 6.3262 14.8605 C 6.5635 15 7.0255 15 7.9496 15 L 16.0504 15 Z"
                  fill="#949494"
                />
              </svg>
            </div>
            <div className="custom-container">
              <div className="custom-box ">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="#949494"
                    strokeWidth="1.25"
                    viewBox="0 0 20 20"
                  >
                    <rect
                      x="2.29102"
                      y="2.29169"
                      width="15.4167"
                      height="15.4167"
                      rx="1.875"
                    />
                  </svg>
                </div>
                <div className="custom-text">Show my task only</div>
              </div>
              <div className="custom-box2">
                <div className="group">Group By</div>
                <div class="group-select">
                  <select
                    id="workflow-select"
                    name="workflow"
                    class="workflow-select"
                  >
                    <option value="">Workflow No.</option>
                  </select>
                </div>
              </div>
              <div className="custom-box3">
                <div className="sort-by">Sort By</div>
                <div class="group-select">
                  <select id="date-select" name="date" class="date-select">
                    <option value="">Date Due</option>
                    <option value="">Assigned to</option>
                    <option value="">Date Completed</option>
                    <option value="">Date in</option>
                    <option value="">Document no.</option>
                    <option value="">Step Name</option>
                    <option value="">Workflow Name</option>
                    <option value="">Workflow No.</option>
                  </select>
                </div>
              </div>
              <div className="custom-box4">
                <div className="show">Show</div>
                <div class="group-select">
                  <select id="page-select" name="page" class="page-select">
                    <option value="">25</option>
                    <option value="">50</option>
                    <option value="">75</option>
                    <option value="">100</option>
                  </select>
                </div>
                <div className="per-page">per page</div>
              </div>
              <div className="">
                <button
                  className="add-remove-column"
                  onClick={() => alert("Add/Remove Columns clicked")}
                >
                  Add/Remove Columns
                </button>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="clear">Clear</div>
            <div className="search1">Search</div>
          </div>
        </div>
        <div className="workflow-bottom">
          <div className="reports">
            <div class="group-select">
              <select id="report-select" name="report" class="report-select">
                <option value="">Reports</option>
              </select>
            </div>
            <div className="delegate">Delegate</div>
          </div>
          <div className="table-wrapper">
            <div className="scrollable-table">
              <table>
                <thead>
                  <tr>
                    <th>
                      <input type="checkbox" title="Select All" />
                    </th>
                    {headers.slice(1).map((header, idx) => (
                      <th key={idx}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sampleData.map((row, idx) => (
                    <React.Fragment key={idx}>
                      {/* Supplementary Row with Collapse Icon */}
                      <tr className="workflow-row">
                        <td colSpan={headers.length}>
                          <div className="workflow-info">
                            <button
                              className="collapse-button"
                              onClick={() => toggleRow(idx)}
                              title="Toggle row"
                            >
                              {openRows[idx] ? (
                                <svg
                                  width="51"
                                  height="36"
                                  viewBox="0 0 51 36"
                                  fill="none"
                                >
                                  <rect
                                    x="15.5"
                                    y="11.5"
                                    width="13"
                                    height="13"
                                    rx="3.25"
                                    stroke="#181818"
                                  />
                                  <path
                                    d="M 17.916 18 H 26.0827"
                                    stroke="#181818"
                                    strokeWidth="1.125"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="51"
                                  height="36"
                                  viewBox="0 0 51 36"
                                  fill="none"
                                >
                                  <rect
                                    x="15.5"
                                    y="11.5"
                                    width="13"
                                    height="13"
                                    rx="3.25"
                                    stroke="#181818"
                                  />
                                  <path
                                    d="M 21.9993 13.9167 V 22.0834 M 17.916 18.0001 H 26.0827"
                                    stroke="#181818"
                                    strokeWidth="1.125"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </button>
                            <span className="supplementary">
                              {row.usergroup}
                            </span>
                            <span className="workflow-no">
                              Workflow No.: {row.workflowNo}
                            </span>
                            <span className="doc-title" onClick={() => navigate(`/document-title`)}>Name: {row.name}</span>
                          </div>
                        </td>
                      </tr>

                      {/* Collapsible Row */}
                      {openRows[idx] && (
                        <tr>
                          <td>
                            <input type="checkbox" />
                          </td>
                          <td>{row.docNo}</td>
                          <td>{row.revision}</td>
                          <td>{row.version}</td>
                          <td>{row.title}</td>
                          <td>{row.initiator}</td>
                          <td>{row.stepName}</td>
                          <td className="action-cell">
                            <div className="action-icons">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                {/* Example SVG: Eye Icon */}
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 4.5C7.30558 4.5 3.23278 7.90267 1.5 12C3.23278 16.0973 7.30558 19.5 12 19.5C16.6944 19.5 20.7672 16.0973 22.5 12C20.7672 7.90267 16.6944 4.5 12 4.5Z"
                                />
                                <circle cx="12" cy="12" r="3" />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                onClick={() => navigate(`/document-review`)}
                              >
                                {/* Example SVG: Trash Icon */}
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M6 7h12M10 11v6m4-6v6M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                                />
                              </svg>
                            </div>
                          </td>
                          <td>{row.assignedTo}</td>
                          <td>{row.dateIn}</td>
                          <td>{row.dateDue}</td>
                          <td>{row.ogDueDate}</td>
                          <td>{row.dateCompleted}</td>
                          <td>{row.stepStatus}</td>
                          <td>{row.stepOutcome}</td>
                          <td>{row.daysLate}</td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            {/* CSS */}
            <style jsx>{`
              .table-wrapper {
                // padding: 16px;
              }

              .scrollable-table {
                overflow-x: auto;
                border: 1px solid #ccc;
              }

              table {
                width: max-content;
                min-width: 100%;
                border-collapse: collapse;
              }

              th,
              td {
                border: 1px solid #dcdcdc;
                padding: 10px 12px;
                font-size: 14px;
                white-space: nowrap;
              }

              th {
                background-color: #f0f0f0;
                font-weight: bold;
              }

              .workflow-row td {
                background-color: #eef6fd;
                padding: 10px;
              }

              .workflow-info {
                display: flex;
                align-items: center;
                gap: 15px;
              }

              .supplementary {
                background-color: #d7ebff;
                color: #003b63;
                padding: 4px 8px;
                border-radius: 4px;
                font-weight: 600;
              }

              .workflow-no {
                font-weight: 500;
              }

              .doc-title {
                color: #0074cc;
                text-decoration: underline;
                font-weight: 500;
              }

              .collapse-button {
                background: none;
                border: none;
                cursor: pointer;
                padding: 0;
              }

              .action-cell {
                vertical-align: middle;
                height: 90px; /* Set your desired height */
              }

              .action-icons {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 6px; /* spacing between icons */
                justify-content: center;
                height: 100%;
              }

              .action-icons svg {
                cursor: pointer;
              }
            `}</style>
          </div>
          <div class="pagination-container">
            <div class="pagination-info">
              <strong>1–13</strong> of 13 Results{" "}
              <span>(0 Selected)</span>
            </div>
            <div class="pagination-controls">
              <button class="page-btn" disabled>
                ‹ Prev
              </button>
              <button class="page-btn active">1</button>
              <button class="page-btn">2</button>
              <button class="page-btn">Next ›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
